var constants = require('../constants');
var api = require('../../../utils/api');
var commonActions = require('../../common/actions/common');

var Trials = (function() {

    var _requestTrials = function() {
      return {
        type: constants.REQUEST_TRIALS
      };
    }

    var _receiveTrials = function(data) {
      return {
        type: constants.RECEIVE_TRIALS,
        trialsData: data.trials
      };
    }

    var _fetchTrials = function(page = 1, filter = "") {
      return function (dispatch) {
        dispatch(_requestTrials());
        return api.get(`/proxy/v1/trials?page=${page}&filter=${filter}`)
          .then(function (data) {
            dispatch(_receiveTrials(data));
          }).catch(function(error){
            console.log(error.message)
            if(error.response){
              // console.log(error.response);
            }else{
              dispatch(commonActions.setGenericError('', error.message));
            }
          });
      };
    }

    var _shouldFetchTrials = function(state) {
      var trials = state.trials
      if (!(trials.items && trials.items[0])) {
        return true
      } else {
        return false
      }
    }

    var _fetchTrialsIfNeeded = function(page, filter) {
      return function(dispatch, getState) {
        if (_shouldFetchTrials(getState())) {
          return dispatch(_fetchTrials(page, filter))
        }
      }
    }

    return {
        fetchTrialsIfNeeded: _fetchTrialsIfNeeded
    }
})();

module.exports = Trials;



// WEBPACK FOOTER //
// ./src/common/modules/trials/actions/trials.js